import React, { FC } from 'react';

import { Link } from 'react-router-dom';

interface ConditionalLinkProps {
  withLink: boolean;
  to?: string;
  className?: string;
}

const ConditionalLink: FC<ConditionalLinkProps> = ({ withLink, children, ...props }) => {
  return withLink ? <Link {...props}>{children}</Link> : <>{children}</>;
};

export default ConditionalLink;
